<template>
  <div id="app">
    <div class="timerBox">
      <div class="title">
        <h1>Online<wbr> Meditation Timer</h1>
        <p>Meditate for 3, 5, 10, 15 or 20 minutes with our timer in silence. Ends with a single singing bowl sound.</p>
      </div>
      <div class="time-select">
        <button v-bind:class="{'is-active': timerLength == 3}" @click.prevent="setTime(3)">3 {{timeUnit}}</button>
        <button v-bind:class="{'is-active': timerLength == 5}" @click.prevent="setTime(5)">5 {{timeUnit}}</button>
        <button
          v-bind:class="{'is-active': timerLength == 10}"
          @click.prevent="setTime(10)"
        >10 {{timeUnit}}</button>
        <button
          v-bind:class="{'is-active': timerLength == 15}"
          @click.prevent="setTime(15)"
        >15 {{timeUnit}}</button>
        <button
          v-bind:class="{'is-active': timerLength == 20}"
          @click.prevent="setTime(20)"
        >20 {{timeUnit}}</button>
      </div>
      <div class="player-container">
        <audio id="timer-gong-bowl">
          <source src="bowl.mp3" type="audio/mpeg" />
        </audio>
        <img
          id="playStopButton"
          :src="playStopButtonImg"
          alt="start or stop the meditation timer"
          height="100px"
          width="100px"
          v-bind:class="{play: !running}"
          @click.prevent="toggleTimer"
        />
        <svg
          class="track-outline"
          width="453"
          height="453"
          viewBox="0 0 453 453"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="226.5" cy="226.5" r="216.5" stroke="#D6CCC4" stroke-width="20" />
        </svg>
        <svg
          class="moving-outline"
          width="453"
          height="453"
          viewBox="0 0 453 453"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="226.5" cy="226.5" r="216.5" stroke="#3C2F36" stroke-width="20" />
        </svg>

        <h3 class="time-display">{{timeDisplay}}</h3>
      </div>

          <div><p class="has-text-centered">More: <a href="digital">minimal digital timer</a></p> 
          </div>


    </div>
        <footer>
      <a href="https://mindfuldevmag.com/" target="_blank"><img src="https://mindfuldevmag.com/logo-small-space.png" alt="mindfuldevmag logo" /></a>
      &rarr; <a href="https://mindfuldevmag.com/products" target="_blank">More Tools</a>&nbsp;
      <br>
      <small>
        <a href="/impressum" target="_blank" rel="nofollow">Imprint</a> -
        <a href="/datenschutz" target="_blank" rel="nofollow">Privacy Policy</a>
      </small>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data: function() {
    return {
      timerLength: 3,
      running: false,
      timeDisplay: "3:00",
      playStopButtonImg: "play.svg",
      interval: null,
      outlineLength: 0
    };
  },
  mounted: function() {
    const outline = document.querySelector(".moving-outline circle");
    this.outlineLength = outline.getTotalLength();
    if (this.outlineLength === 0) {
      this.outlineLength= 2 * Math.PI * outline.getAttribute('r');
    }
    outline.style.strokeDashoffset = this.outlineLength;
    outline.style.strokeDasharray = this.outlineLength;
  },
  computed: {
    timeUnit: function() {
      if (window.innerWidth < 600) {
        return "Min"
      }
      return "Minutes"
    }
  },
  methods: {
    setTime: function(time) {
      this.timerLength = time;
      this.timeDisplay = time + ":00";
    },
    toggleTimer: function() {
      if (this.running) {
        if (this.interval !== null) {
          clearInterval(this.interval);
        }
        this.running = false;
        this.playStopButtonImg = "play.svg";
      } else {
            const outline = document.querySelector(".moving-outline circle");
    outline.style.strokeDashoffset = this.outlineLength;
    outline.style.strokeDasharray = this.outlineLength;
        this.running = true;
        this.playStopButtonImg = "stop.svg";
        var self = this;
        var addTime = 1000 * 60 * parseInt(this.timerLength);
        var startDate = new Date();
        var countDownDate = new Date();
        countDownDate.setTime(startDate.getTime() + addTime);

        this.interval = setInterval(function() {
          var now = new Date();
          var distance = countDownDate - now;

          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          var distanceReverse = now - startDate
          var secondsReverse = Math.floor(distanceReverse / 1000);
          console.log(secondsReverse)
          
          let progress = self.outlineLength - (secondsReverse / (self.timerLength * 60)) * self.outlineLength;
          outline.style.strokeDashoffset = progress;

          self.timeDisplay =
            minutes + ":" + ("0" + seconds).slice(-2);
          console.log(self.timeDisplay)
          if (distance < 0) {
            self.timeDisplay = "00:00";
            clearInterval(self.interval);
            self.running = false;
            self.playStopButtonImg = "play.svg";
            self.interval = null;
            var gongAudio = document.getElementById("timer-gong-bowl");
            gongAudio.play();
          }
        }, 100);
      }
    }
  }
};
</script>

<style>
/* nunito-regular - latin */
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Regular"), local("Nunito-Regular"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-italic - latin */
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-weight: 400;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Italic"), local("Nunito-Italic"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-700 - latin */
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Bold"), local("Nunito-Bold"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-700italic - latin */
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-weight: 700;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Bold Italic"), local("Nunito-BoldItalic"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.eot");
  /* IE9 Compat Modes */
  src: local("Nunito SemiBold"), local("Nunito-SemiBold"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.title {
  text-align: center;
  margin-bottom: 0;
  padding: 10px;
}
.title h1 {
  font-weight: 700;
  margin-bottom: 10px;
  padding: 10px;
}
.title p {
  margin: 0;
  padding: 10px;
}

footer {

  height: 50px;
  text-align: center;
  vertical-align: middle;
  
}
footer img {
  height: 70%;
  vertical-align: middle;
}

footer a,
footer small {
  color: #3c2f36;
}


body {
  background-color: #e8e4de; /*#46DDAB !important;*/
  font-family: "Nunito", sans-serif;
}

#app {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
}

.timerBox {
  height: 95%;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
}
.time-select {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-flow: wrap;
  flex-direction: row;
  flex: 1;
}

.is-active {
  border-color: #84787a !important;
  color: #84787a !important;
}
.time-select button {
  color: #d6ccc4;
  margin: 5px;
  padding: 5px;
  background: none;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  border: 2px solid #d6ccc4;
  transition: all 0.5s ease;
  outline: none;
}
.player-container {
  
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  flex: 20;
}
.player-container img {
  position: relative;
  top: -10%;
}
.player-container svg {
  position: absolute;
  height: 60%;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  pointer-events: none;
}

.player-container svg circle {
  transition: stroke-dashoffset 1s linear;
}
.time-display {
  color: #3C2F36;
  position: absolute;
  font-size: 50px;
  bottom: 10%;
}

.play {
  margin-left:20px;
}

@media only screen and (max-width: 350px) {
p {
  font-size: 12px !important;
}
h1, p {
  margin: 0 !important;
  padding: 0px !important;
}
.time-select button {
  color: #d6ccc4;
  margin: 5px;
  padding: 5px;
  background: none;
  font-size: 12px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #d6ccc4;
  transition: all 0.5s ease;
  outline: none;
}
}

</style>
